module.exports = __webpack_public_path__ + "static/phbomfim3-e1a875323d76130a5e2c840e0e2f500c.png";